/* eslint-disable no-param-reassign */
import React, { useEffect, useRef, useState } from 'react';
import ReactFlow, { ReactFlowProvider } from 'react-flow-renderer';
import NodeFlow from './NodeFlow';
import { ReactFlowExtraEffects } from './ReactFlowExtraEffects';

import './CanvasFlow.css';

/** Canvas da representação do fluxo */
const CanvasFlow = (props) => {
  const reactFlowProvider = useRef(null);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);
  const [canvasClasses, setCanvasClasses] = useState('CanvasFlow');

  /* Manipulador da ação de remoção de elementos no canvas */
  const onElementsRemoveHandler = (elementsToRemove) => {
    if (props.removeElementFlow) props.removeElementFlow(elementsToRemove);
  };

  /* Manipulador da ação de carregamento do elementos no canvas */
  const onLoadHandler = (_reactFlowInstance) => {
    setReactFlowInstance(_reactFlowInstance);
  };

  /** Ajusta os limites do canvas, garantido que somente seja possivel
     rolar ou arrasta o canvas verticalmente. Garante que não seja possivel
     mover o fluxo para baixo quando o primeiro nó estive no topo.
     Garante que não seja possivel mover o fluxo para cima a
     ponto de esconder todo o fluxo fora do canvas */
  const adjustCanvasBounds = () => {
    const x = reactFlowInstance.toObject().position[0];
    const y = reactFlowInstance.toObject().position[1];
    let lastYPosition = Object.values(props.flow).find((e) => e.lastNode);
    lastYPosition = lastYPosition ? lastYPosition.position.y : null;

    // Bloquea movimentos na horizontal
    if (x !== 0) {
      reactFlowInstance.setTransform({ x: 0, y, zoom: 1 });
    }

    // Bloquea descer o fluxo quando o primeiro elemento estiver no topo
    if (y > 0) {
      reactFlowInstance.setTransform({ x: 0, y: 0, zoom: 1 });
      setCanvasClasses('CanvasFlow');
    }

    // Bloque subir o fluxo quando o ultimo elemento estiver no topo
    if (lastYPosition && y < -lastYPosition) {
      reactFlowInstance.setTransform({ x: 0, y: -lastYPosition, zoom: 1 });
      setCanvasClasses('CanvasFlow');
    }
  };

  const adjustMousePointer = () => {
    const grabbingStyle = `${canvasClasses} Grabbing`;
    if (canvasClasses !== grabbingStyle) setCanvasClasses(grabbingStyle);
  };

  /* Manipulador da ação de movimentação do canvas.
     Chamando quando o canvas e arrastado ou rolado */
  const onMoveHandler = () => {
    adjustMousePointer();
    adjustCanvasBounds();
  };

  /** Foca o centro do canvas no nó enviado em props.nodeOnFocus
   */
  const focusOnNode = () => {
    const reactFlowBounds = reactFlowProvider.current.getBoundingClientRect();
    const halfOfCanvasHeight = reactFlowBounds.height / 2;

    const nodeOnFocus = props.flow[props.nodeOnFocus];
    let yPosition = nodeOnFocus.position.y;
    // if (yPosition < halfOfCanvasHeight) return null;

    yPosition = -(yPosition - halfOfCanvasHeight + 120);

    reactFlowInstance.setTransform({
      x: 0,
      y: yPosition,
      zoom: 1,
    });

    props.setNodeOnFocus(null);
  };

  /** Efeito executado em toda atualização do componente    */
  useEffect(() => {
    if (props.nodeOnFocus) focusOnNode();
  });

  /** Quando o canvas e renderizado, ele utiliza o componente NodeFlow para renderizar cada nó,
   *  as propriedades usada para customizar um NodeFlow são colocadas no objeto data do nó */
  return (
    <div className="CanvasFlowConteiner">
      <div ref={reactFlowProvider} className={canvasClasses}>
        <ReactFlowProvider>
          <ReactFlow
            elements={Object.values(props.flow)}
            onElementsRemove={onElementsRemoveHandler}
            onLoad={onLoadHandler}
            nodeTypes={{ NodeFlow }}
            deleteKeyCode={null}
            panOnScroll
            zoomOnDoubleClick={false}
            zoomOnScroll={false}
            nodesDraggable={false}
            nodesConnectable={false}
            selectNodesOnDrag={false}
            onSelectionChange={props.selectNode ? props.selectNode : () => null}
            panOnScrollSpeed={0.8}
            onMove={() => onMoveHandler(reactFlowInstance)}
            onMoveEnd={() => setCanvasClasses('CanvasFlow')}
          />
          <ReactFlowExtraEffects {...props} />
        </ReactFlowProvider>
      </div>
    </div>
  );
};

export default CanvasFlow;
